import React, { useState } from 'react';
import DemoBanner from '../../components/DemoBanner';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLinkedin, FiArrowRight, FiCheck, FiSearch } = FiIcons;

const LinkedInCheck = () => {
  const [role, setRole] = useState('');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [result, setResult] = useState(null);

  const handleAnalyze = () => {
    setIsAnalyzing(true);
    setTimeout(() => {
      setResult({
        headline: `${role} | Specialist in efficiëntie & resultaat | 5+ jaar ervaring`,
        keywords: ['Project Management', 'Stakeholder Management', role, 'Procesoptimalisatie'],
        about: "Gedreven professional met een passie voor het behalen van meetbare resultaten..."
      });
      setIsAnalyzing(false);
    }, 1200);
  };

  return (
    <div className="min-h-screen py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <DemoBanner />
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiLinkedin} className="text-blue-600 text-2xl" />
          </div>
          <h1 className="text-4xl font-bold text-brand-dark mb-4">LinkedIn optimalisatie</h1>
          <p className="text-gray-600">Deze tool werkt direct in je browser. Geen account. Geen kosten. Geen data-opslag.</p>
        </div>

        <div className="bg-white p-8 rounded-2xl border border-gray-200 mb-12">
          <label className="block font-bold mb-4 text-lg">Voor welke rol wil je vindbaar zijn?</label>
          <div className="flex gap-4">
            <input 
              type="text" 
              value={role}
              onChange={(e) => setRole(e.target.value)}
              placeholder="Bijv. Projectmanager of Recruiter"
              className="flex-1 p-4 border rounded-xl outline-none focus:ring-2 focus:ring-brand-orange"
            />
            <button 
              onClick={handleAnalyze}
              disabled={isAnalyzing || !role}
              className="px-8 bg-brand-dark text-white rounded-xl font-bold hover:bg-gray-800 transition-all disabled:bg-gray-300"
            >
              Start
            </button>
          </div>
        </div>

        {result && (
          <div className="space-y-8 animate-fade-in">
            <div className="bg-white p-8 rounded-2xl border border-gray-200">
              <h3 className="font-bold text-xl mb-4 flex items-center gap-2">
                <SafeIcon icon={FiCheck} className="text-green-600" /> Headline Suggestie
              </h3>
              <p className="bg-blue-50 p-4 rounded-xl font-medium text-blue-900 border border-blue-100">{result.headline}</p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-gray-200">
              <h3 className="font-bold text-xl mb-4 flex items-center gap-2">
                <SafeIcon icon={FiSearch} className="text-brand-orange" /> Belangrijke Keywords
              </h3>
              <div className="flex flex-wrap gap-3">
                {result.keywords.map((kw, i) => (
                  <span key={i} className="px-4 py-2 bg-gray-100 rounded-full text-sm font-semibold">{kw}</span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LinkedInCheck;